import moment from "moment";

/**
 * Formats a file form input.files to base 64.
 *
 * @param   {File} file    File form input.files
 * @returns {Promise}
 */
export function getFileBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export const checkSessionTimeStatus = ({ duration, startDateTime }) => {
  const sessionStartTime = moment(startDateTime, "YYYY-MM-DD HH:mm:ss");
  const sessionEndTime = moment(startDateTime, "YYYY-MM-DD HH:mm:ss").add(
    duration,
    "hours"
  );
  const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
  if (sessionStartTime.diff(currentDateTime, "hours") > 0) {
    return "FUTURE";
  } else if (
    sessionStartTime.diff(currentDateTime, "hours") <= 0 &&
    sessionEndTime.diff(currentDateTime, "hours") >= 0
  ) {
    return "PRESENT";
  } else {
    return "PAST";
  }
};

export const debounceMethod = (func) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), 300);
  };
};


export const progressBarColor = (percent) => {
  if (percent <= 60) {
    return "#F68C5080";
  } else if (60 < percent && percent < 90) {
    return "#67BD4A80";
  } else if (90 <= percent) {
    return "#238B3C80";
  }
};